<template>
  <div class="container containerwrap">
    <mt-header fixed title="个人名片" class="head" >
      <!-- <router-link to="/account" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link> -->
    </mt-header>
    <div class="bgImgWrap">
        <img class='backgroundImg' :src="bgimgurl">
    </div>
    <div class="contentWrap">
        <div class="personInfoWrap c_flex c_flex_around c_item_center">
        <div class="personInfoLeft c_flex c_flex_center">
        <img class="personphoto_img" :src="personInfo.headimgurl">
        </div>
        <div  class="personInfoRight">
        <div class="yhlogoWrap c_clear">
            <img class='yhlogoImg c_rt' :src="yhlogourl">
        </div>
        <div class="personInfoBase left_sx c_clear c_m_t_10">
            <div class="c_m_l_10"><p class="f_size_5 line_height_1 ">{{personInfo.username}}</p></div>
            <div class=" c_flex c_m_l_10 c_m_t_10">
                <p class="f_size_35 line_height_1 ">{{personInfo.roleName}}</p>
                <!-- <p class="f_size_35 line_height_1" wx:for="{{personInfo.roleList}}" wx:for-item="item" wx:for-index="i" wx:key="k">
                {{item.rolename}}<p wx:if="{{i!=(personInfo.roleList.length-1)}}">/</p>
                </p> -->
            </div>
        </div>
        <div class="personInfoStar c_m_t_10 c_flex">
            <!-- <block wx:for='{{personInfo.userlevel}}' wx:key='un'>
                <mp-icon type="field" icon="star" color="#f8da56" size="{{20}}"></mp-icon>
            </block> -->
            <img class= "imgstar" v-for="index of personInfo.userlevel" src="../assets/images/star2.png">
        </div>
        <div class="personphone c_flex">
            <img class='phoneiconImg' :src="phoneiconurl">
            <p class="c_m_l_10 f_size_4  "> 
              <a :href="'tel:'+telephone">{{personInfo.phone}}</a>
            </p>
        </div>
        </div>
    </div>
    <div class="otherInfoWrap c_flex c_flex_around">
        <div class="otherInfoLeft">
        <div class="otherInfoItem left_sx">
            <div class="c_m_l_10">
            <p class="f_size_4 otherInfoTitle">所属运营中心</p>
            </div>
            <div class="c_m_l_10 c_m_t_10">
            <p class="f_size_4 otherInfoContent">{{personInfo.orgname}}</p>
            </div>
        </div>
        <div class="otherInfoItem left_sx c_m_t_10">
            <div class="c_m_l_10">
            <p class="f_size_4 otherInfoTitle">联系地址</p>
            </div>
            <div class="c_m_l_10 c_m_t_10">
            <p class="f_size_4 otherInfoContent">{{personInfo.orgaddress}}</p>
            </div>
        </div>
        </div>
        <div class="otherInfoRight">
        <div class="c_clear">
            <p class="otherInfoTitle c_rt">状态</p>
        </div>
        <div>
            <div class="c_flex c_flex_center" v-if="personInfo.working==1">
            <div class="workState ison"></div>
            <p class="c_m_l_10 f_size_35">在职</p>
            </div>
            <div class="c_flex c_flex_center" v-if="personInfo.working==0">
            <div class="workState isoff"></div>
            <p class="c_m_l_10 f_size_35">离职</p>
            </div>
        </div>
        </div>
    </div>
    <div class="infoc_m_r_60">
        <div class="toShopButton" @click="toshop">跳转商城</div>
        <!-- <button class="toShopButton" lang="zh_CN" bindtap="toShopMailBtn">
            前往商城
        </button> -->
    </div>
    <div class="c_m_t_10 c_center">
        <p class="f_size_35">了解更多资讯 尽在雨虹防水</p>
    </div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: "personalinfo",
  data: function() {
    return {
      qiniu: this.$$api.mobile.qiniuDownload,
      bgimgurl: this.$$api.mobile.qiniuDownload + "935349062050530848",
      phoneiconurl: this.$$api.mobile.qiniuDownload + "3395632015951021835",
      yhlogourl: this.$$api.mobile.qiniuDownload + "7267873304259346707",
      // 记录分享人id
      shareUserId: "",
      // 当前登录人或者分享人id
      currentUserId: "",
      personInfo: {
        headimgurl: "",
        userlevel: 0,
        phone: "",
        roleName: "",
        username: "",
        orgname: "",
        working: 0,
        orgaddress: ""
      },
      shopmailurl: "",
      telephone:"",
      params:{},
      shareurl:"",
    };
  },
  computed: {},
  created: function () {
    var that = this;
  },
  mounted: function() {
    debugger
    this.$wxapi.wxRegister(this.wxRegCallback);
    let shareUserId = this.$route.query.shareuserid;
    if (shareUserId) {
      this.shareUserId = shareUserId;
    }
    console.log(shareUserId);
    this.initdata();
    // console.log(this.shopmailurl);
  },
  methods: {
    wxRegCallback () {
      // 用于微信JS-SDK回调
      this.wxShareTimeline();
      this.wxShareAppMessage();
    },
    wxShareTimeline () {
      // debugger
      // 微信自定义分享到朋友圈
      console.log(window.location.href);
      var username = this.personInfo.username;
      var sharetitle="";
      if(username || username == ""){
          sharetitle = "雨虹防水维修服务-"+username;
      }else{
          sharetitle = "雨虹防水维修服务";
      }
      let option = {
        title: sharetitle, // 分享标题, 请自行替换
        link:  window.location.href,
        imgUrl: this.$$api.mobile.qiniuDownload + "8003335209273279344", // 分享图标, 请自行替换，需要绝对路径
        success: () => {
          console.log('分享成功');
        },
        error: () => {
          console.log('已取消分享');
        }
      }
      // 将配置注入通用方法
      this.$wxapi.ShareTimeline(option)
    },
    wxShareAppMessage () {
      // 微信自定义分享给朋友
      console.log(window.location.href);
      var username = this.personInfo.username;
      var sharetitle="";
      if(username || username == ""){
          sharetitle = "雨虹防水维修服务-"+username;
      }else{
          sharetitle = "雨虹防水维修服务";
      }
      let option = {
        title: sharetitle, // 分享标题, 请自行替换
        desc: '服务百姓，拒绝渗漏！', // 分享描述, 请自行替换
        link: window.location.href,
        imgUrl: this.$$api.mobile.qiniuDownload + "8003335209273279344", // 分享图标, 请自行替换，需要绝对路径
        success: () => {
          console.log('分享成功');
          // alert(option.link);
        },
        error: () => {
          console.log('已取消分享')
        }
      }
      // 将配置注入通用方法
      this.$wxapi.ShareAppMessage(option)
    },
    initdata: function() {
      var that = this;
      var personInfoH = {
        headimgurl: "",
        userlevel: 0,
        phone: "",
        roleName: "",
        username: "",
        orgname: "",
        working: 0,
        orgaddress: ""
      };
      var getuserurl = this.$$api.mobile.getLoginUserDetail;
      var getuserdata = {token: "03c470d33cbd8cb8d47204a7afbishui"};
      if (this.shareUserId) {
        getuserurl = this.$$api.mobile.getUserInfoById;
        getuserdata = {
          userid: this.shareUserId,
          token: "03c470d33cbd8cb8d47204a7afbishui"
        };
      }
      // console.log(getuserurl);
      // console.log(JSON.stringify(getuserdata));
      this.$ajax.get(getuserurl, getuserdata, function(res) {
        var msg = res.data.detailMsg.data;
        if (msg) {
          //分享页面重定向 避免微信url自动添加参数
          that.shareurl = that.$$api.mobile.wxsharebaseurl+"personalinfo?shareuserid="+msg.id;
          that.telephone = msg.usermobile;
          personInfoH.phone = that.phoneSeparated(msg.usermobile);
          if (msg.imageurl) {
            if (msg.imageurl.indexOf("http") != -1) {
              personInfoH.headimgurl = msg.imageurl;
            } else {
              personInfoH.headimgurl = that.qiniu + msg.imageurl;
            }
          }
          personInfoH.roleName = msg.levelname;
          personInfoH.username = msg.username;
          personInfoH.working = msg.working;
          personInfoH.orgname = msg.orgname;
          personInfoH.userlevel = msg.userlevel;
          // 如果是顶之美或者顶之美VIP服务组织的人 跳转官方商城
          if (msg.orgname == "顶之美" || msg.orgname == "顶之美VIP服务") {
            that.shopmailurl =
              "https://mall.fangweixiu.com.cn/channel/channel20?wid=gh_81deae50d658&tag=%E5%95%86%E5%9F%8E&areaId=9";
          }
          that.currentUserId = msg.id;
          that.$ajax.get(
            that.$$api.mobile.getAgentDetail,
            { id: msg.orgid,
            token: "03c470d33cbd8cb8d47204a7afbishui"},
            function(res2) {
              var msg2 = res2.data.detailMsg.data;
              if (msg2) {
                if (msg2.fulladdress) {
                  personInfoH.orgaddress = msg2.fulladdress;
                }
                if (msg2.shopurl) {
                  if (
                    msg.orgname != "顶之美" &&
                    msg.orgname != "顶之美VIP服务"
                  ) {
                    that.shopmailurl = msg2.shopurl;
                  }
                }
              }
              console.log(that.shopmailurl);
              that.personInfo = personInfoH;
            }
          );
        } else {
          $that.$toast("获取用户详情失败");
          that.personInfo = personInfoH;
        }
      });
    },
    trim: function(str, is_global) {
      var result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global && is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    // 判断是否是手机号码格式
    isPhone: function(str) {
      var reg = /^1(3|4|5|7|8)\d{9}$/;
      return reg.test(str);
    },
    // 手机号码格式转化为 344 格式 （188 3886 9199）
    phoneSeparated: function(phoneNumber) {
      var that = this;
      let tel = that.trim(phoneNumber, "g");
      if (that.isPhone(tel)) {
        tel =
          tel.substring(0, 3) +
          " " +
          tel.substring(3, 7) +
          " " +
          tel.substring(7, 11);
      }
      return tel;
    },
    toshop: function() {
      // console.log(123);
      if(!(this.shopmailurl) || this.shopmailurl==""){
        this.$toast("商城暂未开放,敬请期待");
      }else{
        window.location.href = this.shopmailurl;
      }
    }
  }
};
</script>

<style scoped>
/* pages/personalinfo/personalinfo.wxss */
page {
  background: #fff;
}
.backgroundImg {
  width: 100%;
  /* height: 100%; */
  /* position:fixed;  */
  background-size: 100% 100%;
  z-index: -1;
  opacity: 0.7;
}
.personInfoWrap {
  width: 100%;
  margin: auto;
  background-color: #ffffff;
  box-shadow: 7px 7px 5px 5px #cccccc;
  -webkit-box-shadow: 7px 7px 5px 5px #cccccc;
  border-radius: 5%;
  height: 60vw;
  z-index: 99;
}
.personInfoLeft {
  width: 45%;
  height: 90%;
  overflow: hidden;
}
.personphoto_img {
  width: 100%;
}
.personInfoRight {
  width: 45%;
  height: 100%;
}
.yhlogoWrap {
  width: 100%;
}
.yhlogoImg {
  width: 10vw;
}
.left_sx {
  border-left: 5px solid #f4b2b2;
  /* border-radius:5px; */
}
/* .personInfoBase p{
  margin-left: 20px;
} */
.personphone {
  margin-top: 25px;
}
.phoneiconImg {
  width: 5vw;
  height: 5vw;
}
.otherInfoLeft {
  width: 75%;
}
/* .otherInfoItem p{
  margin-left: 20px;
} */
.otherInfoTitle {
  color: #a9a9a9;
}
.otherInfoContent {
  font-weight: bold;
}
.otherInfoWrap {
  width: 95%;
  margin: 20px auto 0;
}
.workState {
  width: 4vw;
  height: 4vw;
  border-radius: 50%;
}
.ison {
  background-color: #c3f4b2;
}
.isoff {
  background-color: #ebb4b2;
}
.toShopButton {
  width: 50%;
  background-color: #e67979;
  color: #ffffff;
  padding: 0.2rem 0.3rem;
  border-radius: 5px;
  color: #fff;
  margin: auto;
  font-size: 5vw;
  text-align: center;
}
.infoc_m_r_60 {
  margin-top: 10vw;
}
.line_height_1 {
  /* line-height: 1; */
}
.bgImgWrap {
  position: absolute;
  top: 0;
  z-index: 0;
}
.contentWrap {
  position: absolute;
  top: 40vw;
  z-index: 10;
  width: 85%;
  /* margin: auto; */
  left: 7.5vw;
}
.f_size_6 {
  font-size: 6vw;
}
.f_size_5 {
  font-size: 5vw;
}
.f_size_4 {
  font-size: 4vw;
}
.f_size_35 {
  font-size: 3.5vw;
}
.contentWrap p {
  margin-top: auto;
  margin-bottom: auto;
}
.imgstar {
  width: 5.5vw;
  height: 5.5vw;
}
.containerwrap {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/personalinfo.vue